import { config } from "../../utils/constants";
import { oAuthRequest } from "../../utils/request";
export const getDetails = (sptrn, servCode) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.refundPayment}getDetails`,
    method: 'POST',
    data: {
      servCode: servCode,
      sptrn: sptrn
    }
  };
  return oAuthRequest(requestConfig);
};
export const refundPayment = (sptrn, servCode) => {
  const userId = window.Liferay.ThemeDisplay.getUserId();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.refundPayment}refundPayment`,
    method: 'POST',
    data: {
      servCode: servCode,
      sptrn: sptrn,
      userId: userId
      // userName: userName
    }
  };
  return oAuthRequest(requestConfig);
};